<template>
  <div>    
    <el-select
      v-close-on-zoom
      :value="state.target"
      placeholder="Area"
      class="stethoscope-select"
      :disabled="readonly"
      @input="target => setTarget(target)"
    >
      <el-option
        label="Listen to heart"
        value="HEART_SOUNDS"
      />
      <el-option
        label="Listen to lungs"
        value="LUNG_SOUNDS"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'stethoscope-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        target: 'HEART_SOUNDS',
      },
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.target = get(data, 'id') || 'HEART_SOUNDS';
    this.update();
  },
  methods: {
    setTarget(target) {
      this.state.target = target;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'ASSESSMENT',
        id: this.state.target,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>